import {
  FETCH_SEARCH_REINDEX_REQUESTS,
  FetchSearchReindexRequestsAction,
  RunningSearchReindex,
  SEARCH_REINDEX_COMPLETED,
  SEARCH_REINDEX_STARTED,
  SUBMIT_SEARCH_REINDEX,
  SearchReindexCompletedAction,
  SearchReindexResult,
  SearchReindexStartedAction,
  SubmitSearchReindexAction,
} from "./SearchReindexTypes";

export const submitSearchReindex = (): SubmitSearchReindexAction => {
  return {
    type: SUBMIT_SEARCH_REINDEX.REQUEST,
  };
};

export const searchReindexStarted = (
  payload: RunningSearchReindex,
): SearchReindexStartedAction => {
  return {
    type: SEARCH_REINDEX_STARTED,
    payload,
  };
};

export const searchReindexCompleted = (
  payload: SearchReindexResult,
): SearchReindexCompletedAction => {
  return {
    type: SEARCH_REINDEX_COMPLETED,
    payload,
  };
};

export const fetchSearchReindexRequests =
  (): FetchSearchReindexRequestsAction => {
    return {
      type: FETCH_SEARCH_REINDEX_REQUESTS.REQUEST,
    };
  };
